export default {"src":"/_next/static/media/Socialmedia.57e9aa5b.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};